import React, { useCallback, useState } from 'react';

import SmallButtonStyled from '../../../components/Buttons/SmallButtonStyled';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { formattedDateTime } from '../../../utils/date';
import { PartnerKey } from '../styledComponents';
import doFetch from '../../../api/doFetch';

export default function ({ partnerKey, onDelete }) {
  const [isOpenConfirm, setIsOpenConfirmModal] = useState(false);

  const toggleModal = useCallback(() => setIsOpenConfirmModal(!isOpenConfirm), [isOpenConfirm]);

  const handleDelete = useCallback(async () => {
    const { id, partnerId } = partnerKey;
    const url = `/lotlenz/partners/${partnerId}/keys/${id}`;
    await doFetch(url, { method: 'DELETE' });

    onDelete(partnerKey);
  }, [partnerKey, onDelete]);

  return (
    <PartnerKey>
      <span className='title'>{partnerKey.name}</span>
      <span>{formattedDateTime(partnerKey.createdAt)}</span>
      <SmallButtonStyled className='btn' onClick={toggleModal}>
        Revoke
      </SmallButtonStyled>
      <ConfirmationModal
        title={'REVOKE ACCESS KEY'}
        text={
          'This key will be permanently revoked. If no other active keys remain, the partner will lose access to the system.'
        }
        isOpen={isOpenConfirm}
        toggleHandler={toggleModal}
        confirmAction={handleDelete}
      />
    </PartnerKey>
  );
}
